// extracted by mini-css-extract-plugin
export var imagestyle = "twofleximg-module--imagestyle--84370";
export var normalwrapper = "twofleximg-module--normalwrapper--a4fec";
export var smallerwrapper = "twofleximg-module--smallerwrapper--a4119";
export var twofleximgwrapper = "twofleximg-module--twofleximgwrapper--8d642";
export var twofleximgwrapperp = "twofleximg-module--twofleximgwrapperp--eb505";